import React, { useCallback } from 'react'
import { Range } from 'react-date-range'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from '../Tooltip/Tooltip'
import {
  DateFilterContainer,
  DateFilterWrapper,
} from '../../../pages/Controls/ControlsShowPage/ControlsShowItem/ControlsShowItem.styles'
import { InfoButton } from '../../PageLayout/InfoButton'
import { TrusteroDateRange } from './TrusteroDateRange'
import {
  ClearDateRange,
  ClearDateRangeContainer,
} from './DateRangeFilter.styles'

type DateRangeFilterProps = {
  currentAudit?: string
  dateRange: Range
  setDateRange: React.Dispatch<React.SetStateAction<Range>>
  setDateRangeCb?: () => void
  additionalToolTip?: boolean
  additionalToolTipBody?: string
  hide?: boolean
}

export const DateRangeFilter = ({
  currentAudit,
  dateRange,
  setDateRange,
  setDateRangeCb,
  additionalToolTip,
  additionalToolTipBody,
  hide = false,
}: DateRangeFilterProps): JSX.Element => {
  const isDisabled = Boolean(currentAudit)

  const clearDateRange = useCallback(() => {
    setDateRange({ startDate: undefined, endDate: undefined })
  }, [setDateRange])

  if (hide) {
    return <></>
  }

  return (
    <DateFilterWrapper>
      <DateFilterContainer>
        <TrusteroDateRange
          disabled={isDisabled}
          range={dateRange}
          rangeSet={(range) => {
            setDateRange(range)
            setDateRangeCb?.()
          }}
        />
        {additionalToolTip && (
          <Tooltip
            id="show-latest-tooltip"
            placement={TooltipPositions.top}
            overlayType={TooltipOverlayType.popover}
            tooltipBody={additionalToolTipBody}
          >
            <InfoButton as="div" ml="xxxs" />
          </Tooltip>
        )}
        <ClearDateRangeContainer>
          {!isDisabled && dateRange.startDate && dateRange.endDate && (
            <ClearDateRange onClick={clearDateRange}>Clear</ClearDateRange>
          )}
        </ClearDateRangeContainer>
      </DateFilterContainer>
    </DateFilterWrapper>
  )
}
